export const Path = {
  top: '/',
  about: '/about',
  service: '/service',
  works: '/works',
  privacy: '/privacy',
  recruit: 'https://forms.gle/PpWsg6hknAkvic8T9',
  contact: 'https://forms.gle/TEr6ZgWpuyAJDonN6',
};
